import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SupportComponent } from './support/support.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonService } from '../services/rest/common.service';
import { DirectivesModule } from '../directives/directives.module';
import { WalkthroughComponent } from './walkthrough/walkthrough.component';
import { ImageCropperComponent } from './image-cropper/image-cropper.component';
import { OtpVerifyComponent } from './otp-verify/otp-verify.component';
import { ImageCropperModule } from 'ngx-image-cropper';

@NgModule({
  declarations: [
    SupportComponent,
    WalkthroughComponent,
    ImageCropperComponent,
    OtpVerifyComponent
  ],
  imports: [
    ReactiveFormsModule,
    DirectivesModule,
    CommonModule,
    ImageCropperModule
  ],
  providers:[
    CommonService
  ],
  exports: [
    SupportComponent,
    WalkthroughComponent,
    ImageCropperComponent,
    OtpVerifyComponent
  ]
})
export class AppCommonModule { }
